import { IFontFamily } from '../types';

export const fontFamily: IFontFamily = {
  primary: 'Silverspoon, sans-serif',
  secondary: 'Monserrat, sans-serif',
};
